<template>
  <fragment>
    <transition mode="out-in">
      <div class="col-12" v-if="detalhe">
        <a href="#" class="btn-voltar d-print-none" @click="detalhe = false">
          <span class="material-icons">chevron_left</span> Lista de Faturas
        </a>
        <h1 class="title mt-4 text-uppercase">
          EXTRATO DA FATURA {{ this.nNota }}
        </h1>
        <section class="pdf-item container">
          <div class="bg-white rounded p-4 mt-4 border border-light" v-if="dadosPacote.descPacote">
            <div class="row">
              <div class="col-4">
                <div class="rel-title">PACOTE</div>
                <div class="rel-value-reg">{{ dadosPacote.descPacote }}</div>
              </div>
              <div class="col-4">
                <div class="rel-title">Valor</div>
                <div class="rel-value-reg">
                  {{ 'dadosPacote.valorPacote.VLRAPLIC | currency' }}
                </div>
              </div>
            </div>
          </div>
          <div class="bg-vida rounded p-4 mt-4 border border-light">
            <div class="row align-items-center">
              <div class="col-md-3 rel-value">Detalhes do Boleto</div>
              <div class="col text-right">
                <div class="rel-value">
                </div>
              </div>
            </div>
          </div>
          <!--ExtratoFatura-->
          <Lista class="bg-white rounded pt-3 px-3 w-100" :items="this.itens" />

          <!--AjustePacote-->
          <ListaPacote class="bg-white rounded pt-3 px-3 w-100" :items="this.items" v-if="this.items.length > 0 && this.items[0].vlraplic > 0" />

          <!--VlrAplicacaoNotaFacob-->
          <ListaVlrAplicacao v-if="itensVlrAplicacaoNotaFacob.length > 0 && itensVlrAplicacaoNotaFacob[0].vlraplic > 0" class="bg-white rounded pt-3 px-3 w-100"
            :items="this.itensVlrAplicacaoNotaFacob" />

          <div class="bg-vida rounded p-4 mt-4 border border-light" v-if="itensDescontoGeral.length > 0 && itensDescontoGeral[0].vlrtotaldesconto > 0">
            <div class="row align-items-center">
              <div class="col-md-6 rel-value">Desconto Geral da Nota</div>
              <div class="col text-right">
                <div class="rel-value">
                </div>
              </div>
            </div>
          </div>
          <ListaEstorno v-if="itensDescontoGeral.length > 0 && itensDescontoGeral[0].vlrtotaldesconto > 0" class="bg-white rounded pt-3 px-3 w-100"
                        :items="this.itensDescontoGeral" />

            
          <ListaCredGeralNota v-if="itensCredGeralNota.length > 0 && itensCredGeralNota[0].valor > 0" class="bg-white rounded pt-3 px-3 w-100"
            :items="this.itensCredGeralNota" />

          <div class="bg-vida rounded p-4 mt-4 border border-light">
            <div class="row align-items-center">
              <div class="col-md-3 rel-value">VALOR TOTAL</div>
              <div class="col text-right">
                <div class="rel-value">
                  {{ totalFatura | currency }}
                </div>
              </div>
            </div>
          </div>

        </section>
        <div class="row mt-4 flex-column-reverse flex-md-row">
          <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
            <Botao title="Voltar" @click="detalhe = false" nameClass="btn btn-outline-secondary btn-lg btn-block">VOLTAR
            </Botao>
          </div>
        </div>
      </div>
      <div class="col-12" v-else-if="boletos.length">
        <div class="form-row form_padrao d-none">
          <div class="form-group flutuante col-md-12">
            <input type="text" name="nomeOperador" id="nomeOperador" required autocomplete="off" />
            <label for="nomeOperador">Pesquisar faturas...</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 mt-4" v-for="(boleto, index) in boletos" :key="index">
            <div class="card card_content p-3" v-if="boleto.datA_VENCIMENTO">
              <div class="d-flex justify-content-between align-items-center">
                <i class="material-icons">horizontal_split</i>
                <div v-if="boleto.codsituacao != '01'" class="d-flex">
                  <a @click="buscarDetalhe(boleto.nota, boleto.valoR_TOTAL)" class="badge bg-azul badge-secondary mx-1"
                    link="no-follow">
                    <i class="material-icons">info</i> Detalhe Fatura
                  </a>
                  <div>
                    <a class="badge bg-azul badge-secondary" target="_blank" link="no-follow" v-if="boleto.tipO_PG == '1'">
                      <i class="material-icons">credit_card</i> Débito Automático
                    </a>
                    <a :href="'https://www.sicoob.com.br/web/sicoob/segunda-via-de-boleto?p_p_id=br_com_sicoob_portal_portlets_boletos_EmiteSegundaViaBoletoPortlet&p_p_lifecycle=0&p_p_state=normal&p_p_mode=view&_br_com_sicoob_portal_portlets_boletos_EmiteSegundaViaBoletoPortlet_cooperativaCliente=4030%2F129194&_br_com_sicoob_portal_portlets_boletos_EmiteSegundaViaBoletoPortlet_nossoNumero=' +
                    boleto.nossonumerosicoob +
                    '&_br_com_sicoob_portal_portlets_boletos_EmiteSegundaViaBoletoPortlet_cpfCnpjPag=' +
                    boleto.documento
                    " class="badge bg-azul badge-secondary" target="_blank" link="no-follow" v-else-if="boleto.codsituacao != '01'">
                      <i class="material-icons">get_app</i> Emitir 2 via
                    </a>
                  </div>
                 

                </div>
                <span class="badge badge-alert" style="color: white; background: red" href="" v-else v-tooltip:top="'Entre em contato conosco através dos nossos canais de atendimento'
        ">
                  <i class="material-icons">info</i> Alerta</span>
              </div>
              <div>
                <h6 class="text-uppercase font-weight-bolder">
                  Mensalidade Associado
                </h6>
                <small class="text-muted pt-2">Valor: R$ {{ boleto.valoR_TOTAL }}</small>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <p class="small">Vencimento: {{ boleto.datA_VENCIMENTO }}</p>
                  <p class="small text-uppercase success">
                    {{ "Em aberto" }}
                </p>
                <!-- <p class="small text-uppercase" :class="boleto.situacao == 'ATIVA' ? 'success' : 'danger'">
                  {{ boleto.situacao }}
                </p> -->
              </div>
            </div>
            <div class="card absolute border-0" v-else>
              <h5>Você ainda não possui faturas em aberto. 😃</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-else>
        <loading />
      </div>
    </transition>
  </fragment>
</template>

<script>
import Botao from "@/components/botoes/Botao";
import Lista from "@/components/relatorio/ExtratoFatura";
import ListaPacote from "@/components/relatorio/ExtratoFaturaPacote";
import ListaEstorno from "@/components/relatorio/ExtratoFaturaEstorno";
import ListaVlrAplicacao from "@/components/relatorio/ExtratoFaturaVlrAplicacao";
import ListaCredGeralNota from "@/components/relatorio/ExtratoListaCredGeralNota";

export default {
  name: "Boleto",
  components: { Botao, Lista, ListaPacote, ListaVlrAplicacao, ListaCredGeralNota, ListaEstorno },
  data() {
    return {
      boletos: "",
      produto: {
        nome: "Boleto e Fatura",
        id: "2 via boleto",
      },
      breadcrumb: [
        {
          nome: "Boleto e Fatura",
          id: "2viaboleto",
        },
      ],
      nota: null,
      detalhe: false,
      itens: [],
      items: [],
      itensPacote: [],
      itensDescontoGeral: [],
      itensVlrAplicacaoNotaFacob: [],
      itensCredGeralNota: [],
      totalFatura: 0,
      totalAjustePacote: 0,
      totalItem: 0,
      dadosPacote: {},
      totalVlrTotalAplic: 0
    };
  },
  mounted() {
    // console.log("A");
    this.itens = [];
  },
  methods: {
    buscarDetalhe(nota, valorFatura) {
      this.itens = [];
      this.items = [];
      this.nNota = nota;
      this.totalFatura = 0;
      this.totalFatura = valorFatura;
      this.fetchData();
    },
    async fetchData() {
      try {
        await Promise.all([
          this.fetchExtratoFatura(),
          this.fetchAjustePacote(),
          this.fetchDescontoGeralNota(),
          this.fetchVlrAplicacaoNotaFacob(),
          this.fetchCredGeralNota(),
        ]);
      } catch (error) {
        this.handleErrors(error);
      }
    },
    async fetchExtratoFatura() {
      const response = await this.$http.get(`api/CdlBh/ExtratoFatura?numeroNota=${this.nNota}`);
      this.detalhe = true;
      this.itens = response.data;
    },
    async fetchAjustePacote() {
      const response = await this.$http.get(`api/CdlBh/AjustePacote?numeroNota=${this.nNota}`);
      this.items = [];
      this.items.push(...response.data);
    },
    async fetchDescontoGeralNota() {
      const response = await this.$http.get(`api/CdlBh/DescontoGeralNota?numeroNota=${this.nNota}`);
      this.itensDescontoGeral = [];
      this.itensDescontoGeral = [...response.data];
    },
    async fetchVlrAplicacaoNotaFacob() {
      const response = await this.$http.get(`api/CdlBh/VlrAplicacaoNotaFacob?numeroNota=${this.nNota}`);
      this.itensVlrAplicacaoNotaFacob = [];
      this.itensVlrAplicacaoNotaFacob = [...response.data];
    },
    async fetchCredGeralNota() {
      const response = await this.$http.get(`api/CdlBh/CredGeralNota?numeroNota=${this.nNota}`);
      this.itensCredGeralNota = [];
      this.itensCredGeralNota = [...response.data];
    },
    handleErrors(error) {
      if (error.response && error.response.status === 401) {
        this.$router.push({ name: "login" });
      } else {
        console.error('Error occurred:', error);
      }
    }
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.$http
      .get("/api/CdlBh/ListarFaturas")
      .then((response) => {
        console.log(response);

        this.boletos = response.data;
      })
      .catch((error) => {
        if (error.statusCode === 401) {
          this.$router.push({ name: "login" });
        }
      });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";

.card_content {
  min-height: 170px;
  display: flex;
  justify-content: space-between;

  small {
    line-height: 1.5rem;
  }

  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    cursor: pointer;
    border-radius: 0px;
    background: #05428e;

    i {
      font-size: 13px;
      color: white;
    }
  }

  &:hover {
    transform: scale(1.05);
  }
}

.bg-vida {
  background-color: #e3e6f0;
}

.title {
  color: $primary;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
}

.rel-value {
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  color: #000;
}

.rel-title {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 10px;
}

.rel-value-reg {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}

.btn-voltar {
  color: $primary;
  font-weight: 700;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
}
</style>
